<template>
  <div>
    <WebSocket ref="webSocketRef" v-if="mode == 'm3'" :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
    <Row typw="flex">
      <Col flex="1">
      <Card class="card-container" dis-hover>
        <div slot="title" class="card-title">{{ getTranslation('k074') }}</div>
        <Row class="limit-line" type="flex">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k075') }}
          </Col>
          <Col flex="19">
          <Select :transfer="true" v-model="selScale" class="limit-field" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')" @on-change="scaleChange()">
            <Option v-for="(item, key) in scaleList" :value="key" :key="key">{{ item }}</Option>
          </Select>
          </Col>
        </Row>
        <Row class="limit-line" type="flex" v-if="(selScale == 1)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k150') }}
          </Col>
          <Col flex="19">
          <Select :transfer="true" v-model="selPrimCal" class="limit-field" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')" @on-change="primCalChange()">
            <Option v-for="(item, key) in PriCaleList" :value="key" :key="key">{{ item }}</Option>
          </Select></Col>
        </Row>
        <Row class="limit-line" type="flex" v-if="(selScale == 2)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k155') }}
          </Col>
          <Col flex="19">
          <Select :transfer="true" v-model="selSecCal" class="limit-field" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')" @on-change="secCalChange()">
            <Option v-for="(item, key) in PriCaleList" :value="key" :key="key">{{ item }}</Option>
          </Select></Col>
        </Row>

        <Row class="limit-line" type="flex" v-if="(selScale == 1 && selPrimCal == 0)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k159') }}
          </Col>
          <Col flex="19">
          <Input :transfer="true" v-model="info.OptGun2PrimCurrentAdj" class="limit-field"
            @on-focus="openSettingDialog({ 'titleKey': 'k159', 'toSetValue': info.OptGun2PrimCurrentAdj, 'field': 'OptGun2PrimCurrentAdj' })" />
          </Col>
        </Row>
        <Row class="limit-line" type="flex" v-if="(selScale == 2 && selSecCal == 0)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k160') }}
          </Col>
          <Col flex="19">
          <Input  :transfer="true" v-model="info.OptGun2SecCurrentAdj" class="limit-field"
            @on-focus="openSettingDialog({ 'titleKey': 'k160', 'toSetValue': info.OptGun2SecCurrentAdj, 'field': 'OptGun2SecCurrentAdj' })" />
          </Col>
        </Row>

        <Row class="limit-line" type="flex" v-if="KindOf803(kind) && (selScale == 1 || selScale == 2)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('k149') }}
          </Col>
          <Col flex="19">
          <Input  :transfer="true" v-model="info.OptRsv168" class="limit-field"
            @on-focus="openSettingDialog({ 'titleKey': 'k149', 'toSetValue': info.OptRsv168, 'field': 'OptRsv168' })" />
          </Col>
        </Row>
          <Row class="limit-line" type="flex" v-if="KindOf803(kind) && (selScale == 1 || selScale == 2)">
          <Col flex="5" class="left-program desc-field">{{ getTranslation('s333') }}
          </Col>
          <Col flex="19">
             <Select :transfer="true" v-model="info.OptCurrAdjMod" class="limit-field" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')" @on-change="changeOptCurrAdjMod()">
            <Option v-for="(item, key) in OptCurrAdjModOption" :value="key" :key="key">{{ item }}</Option>
          </Select>         
          </Col>
        </Row>
      </Card>
      </Col>
      <Col flex="1">
      <div v-if="selScale == 0">
        <Card class="card-container" dis-hover>
          <div slot="title" class="card-title">{{ getTranslation('k079') }}</div>
          <Row class="limit-line" type="flex">
            <Col flex="1">
            </Col>
            <Col flex="1">{{ getTranslation('k080') }}
            </Col>
            <Col flex="1">{{ getTranslation('k081') }}
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1" class="cal-switch">
            <i-switch size="large" v-model="opt0Calibration" :before-change="opt0CalibrationChange">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="1"><Input type="number" class="scale-input" :disabled="!opt0Calibration"
              v-model="info.PssGun2ElectrodeCal1Set"
              @on-focus="openSettingDialog({ 'titleKey': 'k164', 'toSetValue': info.PssGun2ElectrodeCal1Set, 'field': 'PssGun2ElectrodeCal1Set' })"></Input>
            </Col>
            <Col flex="1"><Input type="number" class="scale-input" :disabled="!opt0Calibration"
              v-model="info.PssGun2ElectrodeCal1Disp"
              @on-focus="openSettingDialog({ 'titleKey': 'k164', 'toSetValue': info.PssGun2ElectrodeCal1Disp, 'field': 'PssGun2ElectrodeCal1Disp' })"></Input>
            </Col>
          </Row>
        </Card>
      </div>
      <div v-if="selScale == 1">
        <Card class="card-container" dis-hover>
          <div slot="title" class="card-title">{{ getTranslation('k162') }}</div>
          <Row class="limit-line" type="flex">
            <Col flex="1">
            </Col>
            <Col flex="1">
            </Col>
            <Col flex="2">{{ getTranslation('k156') }}
            </Col>
            <Col flex="2">{{ getTranslation('k157') }}
            </Col>
            <Col flex="2">{{ getTranslation('k158') }}
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">8
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration8" :before-change="opt1CalibrationChange8">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MaxPrimWeldCalPwm" :disabled="!opt1Calibration8"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2MaxPrimWeldCalPwm, 'field': 'ValGun2MaxPrimWeldCalPwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2MaxPrimaryCal" :disabled="!opt1Calibration8"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2MaxPrimaryCal, 'field': 'CrrGun2MaxPrimaryCal' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MaxPrimaryCal" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">7
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration7" :before-change="opt1CalibrationChange7">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal6Pwm" :disabled="!opt1Calibration7"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal6Pwm, 'field': 'ValGun2PrimWeldCal6Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal6" :disabled="!opt1Calibration7"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal6, 'field': 'CrrGun2PrimaryCal6' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal6" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">6
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration6" :before-change="opt1CalibrationChange6">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal5Pwm" :disabled="!opt1Calibration6"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal5Pwm, 'field': 'ValGun2PrimWeldCal5Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal5" :disabled="!opt1Calibration6"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal5, 'field': 'CrrGun2PrimaryCal5' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal5" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">5
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration5" :before-change="opt1CalibrationChange5">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal4Pwm" :disabled="!opt1Calibration5"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal4Pwm, 'field': 'ValGun2PrimWeldCal4Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal4" :disabled="!opt1Calibration5"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal4, 'field': 'CrrGun2PrimaryCal4' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal4" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">4
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration4" :before-change="opt1CalibrationChange4">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal3Pwm" :disabled="!opt1Calibration4"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal3Pwm, 'field': 'ValGun2PrimWeldCal3Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal3" :disabled="!opt1Calibration4"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal3, 'field': 'CrrGun2PrimaryCal3' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal3" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">3
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration3" :before-change="opt1CalibrationChange3">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal2Pwm" :disabled="!opt1Calibration3"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal2Pwm, 'field': 'ValGun2PrimWeldCal2Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal2" :disabled="!opt1Calibration3"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal2, 'field': 'CrrGun2PrimaryCal2' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal2" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">2
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration2" :before-change="opt1CalibrationChange2">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimWeldCal1Pwm" :disabled="!opt1Calibration2"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2PrimWeldCal1Pwm, 'field': 'ValGun2PrimWeldCal1Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2PrimaryCal1" :disabled="!opt1Calibration2"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2PrimaryCal1, 'field': 'CrrGun2PrimaryCal1' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2PrimaryCal1" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">1
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt1Calibration1" :before-change="opt1CalibrationChange1">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MinPrimWeldCalPwm" :disabled="!opt1Calibration1"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2MinPrimWeldCalPwm, 'field': 'ValGun2MinPrimWeldCalPwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2MinPrimaryCal" :disabled="!opt1Calibration1"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2MinPrimaryCal, 'field': 'CrrGun2MinPrimaryCal' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MinPrimaryCal" disabled />
            </Col>
          </Row>
        </Card>
      </div>
      <div v-if="selScale == 2 ">
        <Card class="card-container" dis-hover>
          <div slot="title" class="card-title">{{ getTranslation('k163') }}</div>
          <Row class="limit-line" type="flex">
            <Col flex="1">
            </Col>
            <Col flex="1">
            </Col>
            <Col flex="2">{{ getTranslation('k156') }}
            </Col>
            <Col flex="2">{{ getTranslation('k157') }}
            </Col>
            <Col flex="2">{{ getTranslation('k158') }}
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">8
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration8" :before-change="opt2CalibrationChange8">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MaxWeldCalPwm" :disabled="!opt2Calibration8"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2MaxWeldCalPwm, 'field': 'ValGun2MaxWeldCalPwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2MaxSecondaryCal" :disabled="!opt2Calibration8"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2MaxSecondaryCal, 'field': 'CrrGun2MaxSecondaryCal' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MaxSecondaryCal" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">7
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration7" :before-change="opt2CalibrationChange7">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal6Pwm" :disabled="!opt2Calibration7"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal6Pwm, 'field': 'ValGun2WeldCal6Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal6" :disabled="!opt2Calibration7"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal6, 'field': 'CrrGun2SecondaryCal6' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal6" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">6
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration6" :before-change="opt2CalibrationChange6">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal5Pwm" :disabled="!opt2Calibration6"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal5Pwm, 'field': 'ValGun2WeldCal5Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal5" :disabled="!opt2Calibration6"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal5, 'field': 'CrrGun2SecondaryCal5' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal5" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">5
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration5" :before-change="opt2CalibrationChange5">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal4Pwm" :disabled="!opt2Calibration5"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal4Pwm, 'field': 'ValGun2WeldCal4Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal4" :disabled="!opt2Calibration5"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal4, 'field': 'CrrGun2SecondaryCal4' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal4" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">4
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration4" :before-change="opt2CalibrationChange4">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal3Pwm" :disabled="!opt2Calibration4"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal3Pwm, 'field': 'ValGun2WeldCal3Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal3" :disabled="!opt2Calibration4"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal3, 'field': 'CrrGun2SecondaryCal3' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal3" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">3
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration3" :before-change="opt2CalibrationChange3">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal2Pwm" :disabled="!opt2Calibration3"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal2Pwm, 'field': 'ValGun2WeldCal2Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal2" :disabled="!opt2Calibration3"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal2, 'field': 'CrrGun2SecondaryCal2' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal2" disabled />
            </Col>
          </Row>
          <Row class="limit-line table-row-odd" type="flex">
            <Col flex="1">2
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration2" :before-change="opt2CalibrationChange2">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2WeldCal1Pwm" :disabled="!opt2Calibration2"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2WeldCal1Pwm, 'field': 'ValGun2WeldCal1Pwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2SecondaryCal1" :disabled="!opt2Calibration2"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2SecondaryCal1, 'field': 'CrrGun2SecondaryCal1' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2SecondaryCal1" disabled />
            </Col>
          </Row>
          <Row class="limit-line" type="flex">
            <Col flex="1">1
            </Col>
            <Col flex="1">
            <i-switch size="large" v-model="opt2Calibration1" :before-change="opt2CalibrationChange1">
              <span slot="close">OFF</span>
              <span slot="open">ON</span>
            </i-switch>
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MinWeldCalPwm" :disabled="!opt2Calibration1"
              @on-focus="openSettingDialog({ 'titleKey': 'k156', 'toSetValue': info.ValGun2MinWeldCalPwm, 'field': 'ValGun2MinWeldCalPwm' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.CrrGun2MinSecondaryCal" :disabled="!opt2Calibration1"
              @on-focus="openSettingDialog({ 'titleKey': 'k157', 'toSetValue': info.CrrGun2MinSecondaryCal, 'field': 'CrrGun2MinSecondaryCal' })" />
            </Col>
            <Col flex="2">
            <Input type="number" class="limit-field" v-model="info.ValGun2MinSecondaryCal" disabled />
            </Col>
          </Row>
        </Card>
      </div>
      </Col>
    </Row>
    <Modal v-model="openSetting" @on-ok="changeSetting" :title="settingTitle" :okText="getTranslation('b181')"
      :cancelText="getTranslation('b182')">
      <Input type="number" v-model="toSetValue" />
    </Modal>
  </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Card, Row, Col, Select, Option, Input, Switch, Modal } from "view-design"
import { mapGetters } from 'vuex'
import { postJsError,KindOf803 } from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';
export default {
  name: 'CalibrationTwo', // 组件名称
  components: {
    Card, Row, Col, Select, Option, Input,
    'i-switch': Switch, Modal,WebSocket
  },
  props: {
    kind: {
      type: Number,
      default: 803
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      info: {},
      selScale: 0,
      selPrimCal: -1,
      selSecCal: -1,
      openSetting: false,
      toSetValue: '',
      titleKey: '',
      settingField: '',
      opt0Calibration: false,
      opt1Calibration8: false,
      opt1Calibration7: false,
      opt1Calibration6: false,
      opt1Calibration5: false,
      opt1Calibration4: false,
      opt1Calibration3: false,
      opt1Calibration2: false,
      opt1Calibration1: false,
      opt2Calibration8: false,
      opt2Calibration7: false,
      opt2Calibration6: false,
      opt2Calibration5: false,
      opt2Calibration4: false,
      opt2Calibration3: false,
      opt2Calibration2: false,
      opt2Calibration1: false,
      canJump: true,
      lockSocket:false,
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    scaleList() {
      return [
        this.getTranslation("k076"),
        this.getTranslation("k077"),
        this.getTranslation("k078"),
      ]
    },
    PriCaleList() {
      return [
        this.getTranslation("k151"),
        this.getTranslation("k152"),
      ]
    },
    OptCurrAdjModOption() {
      return [
        this.getTranslation("z022"),
        this.getTranslation("s334"),
      ]
    },
    settingTitle() {
      return this.getTranslation(this.titleKey)
    },
    webSocketUrl() {
        return API_URL['webSocket'] + "?mac=" + this.$route.query.mac;
    },
  },
  watch: {
    mode(newVal) {
      if (newVal == 'm3') {
        let _this = this;
        this.$nextTick(() => {
           setTimeout(() => {
          _this.sendWebSocketMessage('calibration2')
          }, 1000);
        })
      }
    }
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      let url = API_URL["systemCalTwoInfo"];
      this.mac = this.$route.query.mac
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.sendWebSocketMessage('calibration2')
            this.info = res.data.data;
            this.scaleChange();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    scaleChange() {      
      if (this.selScale == 1) {
        if (this.selPrimCal == -1) {
          this.selPrimCal = this.info.OptPrimCalDataChoose;
          this.primCalChange();
        }
      } else if (this.selScale == 2) {
        if (this.selSecCal == -1) {
          this.selSecCal = this.info.OptSecCalDataChoose;
          this.secCalChange();
        }
      }
    },
    async primCalChange() {
      this.lockSocket = true;
      let params = new FormData();
      params.append('kind', 'primChoose');
      params.append('value', this.selPrimCal);
      this.settingField = '';
      await this.calibrationCurrentAdj(params);
      setTimeout(()=>{this.lockSocket = false},3000)
    },
    async secCalChange() {
      this.lockSocket = true;
      let params = new FormData();
      params.append('kind', 'secChoose');
      params.append('value', this.selSecCal);
      this.settingField = ''
      await this.calibrationCurrentAdj(params);
      setTimeout(()=>{this.lockSocket = false},3000)
    },
    async calibrationCurrentAdj(params) {
      let url = API_URL["systemCalOneCurrentadj"] + '?mac=' + this.mac;
      let res = await axios.post(url, params);
      if (res && res.data && res.data.code == 200) {
        if (this.settingField == 'OptGun2PrimCurrentAdj') {
          this.info.OptGun2PrimCurrentAdj = params.get('value')
        } else if (this.settingField == 'OptGun2SecCurrentAdj') {
          this.info.OptGun2SecCurrentAdj = params.get('value')
        } else if (this.settingField == 'OptRsv168') {
          this.info.OptRsv168 = params.get('value')
        }
        this.$Message.success(res.data.msg);
      } else if (res && res.data && res.data.msg) {
        this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });

      } else {
        this.$Message.error(this.getTranslation('c001'));
      }

    },    
    async changeOptCurrAdjMod() {
      this.lockSocket=true;
      let params = new FormData();
      params.append('kind', 'optCurrAdjMod');
      params.append('value', this.info.OptCurrAdjMod);
      let url = API_URL["systemCalOneCurrentadj"] + '?mac=' + this.mac;
      let res = await axios.post(url, params);

      if (res && res.data && res.data.code == 200) {
        this.$Message.success(res.data.msg);
      } else if (res && res.data && res.data.msg) {
        this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });

      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
      this.lockSocket = false;
    },  
    async changeSetting() {
      if (this.settingField == 'PssGun2ElectrodeCal1Disp' || this.settingField == 'PssGun2ElectrodeCal1Set') {
        //校准电极压力
        let url = API_URL["systemCalOnePss"] + '?mac=' + this.mac;
        let params = new FormData();
        params.append('OptCalibItem', this.getOptCalibItem());
        params.append('OptCalibActive', this.OptCalibActive());
        if (this.settingField == 'PssGun2ElectrodeCal1Disp') {
          params.append('ValElectrodeCalSet', this.info.PssGun2ElectrodeCal1Set);
          params.append('PssElectrodeCal', this.toSetValue);
        } else {
          params.append('ValElectrodeCalSet', this.toSetValue);
          params.append('PssElectrodeCal', this.info.PssGun2ElectrodeCal1Disp);
        }
        let res = await axios.post(url, params);
        if (res && res.data && res.data.code == 200) {
          if (this.settingField == 'PssGun2ElectrodeCal1Disp') {
            this.info.PssGun2ElectrodeCal1Disp = this.toSetValue;
          } else {
            this.info.PssGun2ElectrodeCal1Set = this.toSetValue;
          }
          this.$Message.success(res.data.msg);
        } else if (res && res.data && res.data.msg) {
          this.$Message.error(res.data.msg);

        } else {
          this.$Message.error(this.getTranslation('c001'));
        }
      } else if (this.settingField == 'OptGun2PrimCurrentAdj' || this.settingField == 'OptGun2SecCurrentAdj' || this.settingField == 'OptRsv168') {
        //电极不同，改这里
        let params = new FormData();
        if (this.settingField == 'OptGun2PrimCurrentAdj') {
          params.append('kind', 'gun2p');
          params.append('value', this.toSetValue);
        } else if (this.settingField == 'OptGun2SecCurrentAdj') {
          params.append('kind', 'gun2s');
          params.append('value', this.toSetValue);
        } else if (this.settingField == 'OptRsv168') {
          params.append('kind', 'optrsv168');
          params.append('value', this.toSetValue);
        }
        this.calibrationCurrentAdj(params)
      } else if (this.settingField == 'ValGun2MaxPrimWeldCalPwm' || this.settingField == 'CrrGun2MaxPrimaryCal') {
        let index = 7;
        let params = {}
        if (this.settingField == 'ValGun2MaxPrimWeldCalPwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2MaxPrimaryCal, 1, index)
        } else if (this.settingField == 'CrrGun2MaxPrimaryCal') {
          params = this.getopt1Param(this.info.ValGun2MaxPrimWeldCalPwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal6Pwm' || this.settingField == 'CrrGun2PrimaryCal6') {
        let index = 6;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal6Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal6, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal6') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal6Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal5Pwm' || this.settingField == 'CrrGun2PrimaryCal5') {
        let index = 5;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal5Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal5, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal5') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal5Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal4Pwm' || this.settingField == 'CrrGun2PrimaryCal4') {
        let index = 4;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal4Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal4, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal4') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal4Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal3Pwm' || this.settingField == 'CrrGun2PrimaryCal3') {
        let index = 3;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal3Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal3, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal3') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal3Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal2Pwm' || this.settingField == 'CrrGun2PrimaryCal2') {
        let index = 2;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal2Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal2, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal2') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal2Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2PrimWeldCal1Pwm' || this.settingField == 'CrrGun2PrimaryCal1') {
        let index = 1;
        let params = {}
        if (this.settingField == 'ValGun2PrimWeldCal1Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2PrimaryCal1, 1, index)
        } else if (this.settingField == 'CrrGun2PrimaryCal1') {
          params = this.getopt1Param(this.info.ValGun2PrimWeldCal1Pwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2MinPrimWeldCalPwm' || this.settingField == 'CrrGun2MinPrimaryCal') {
        let index = 0;
        let params = {}
        if (this.settingField == 'ValGun2MinPrimWeldCalPwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2MinPrimaryCal, 1, index)
        } else if (this.settingField == 'CrrGun2MinPrimaryCal') {
          params = this.getopt1Param(this.info.ValGun2MinPrimWeldCalPwm, this.toSetValue, 2, index)
        }
        this.opt1CalibrationChange(params);
      } else if (this.settingField == 'ValGun2MaxWeldCalPwm' || this.settingField == 'CrrGun2MaxSecondaryCal') {
        let index = 7;
        let params = {}
        if (this.settingField == 'ValGun2MaxWeldCalPwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2MaxSecondaryCal, 1, index)
        } else if (this.settingField == 'CrrGun2MaxSecondaryCal') {
          params = this.getopt1Param(this.info.ValGun2MaxWeldCalPwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2WeldCal6Pwm' || this.settingField == 'CrrGun2SecondaryCal6') {
        let index = 6;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal6Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal6, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal6') {
          params = this.getopt1Param(this.info.ValGun2WeldCal6Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2WeldCal5Pwm' || this.settingField == 'CrrGun2SecondaryCal5') {
        let index = 5;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal5Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal5, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal5') {
          params = this.getopt1Param(this.info.ValGun2WeldCal5Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2WeldCal4Pwm' || this.settingField == 'CrrGun2SecondaryCal4') {
        let index = 4;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal4Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal4, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal4') {
          params = this.getopt1Param(this.info.ValGun2WeldCal4Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }

      else if (this.settingField == 'ValGun2WeldCal3Pwm' || this.settingField == 'CrrGun2SecondaryCal3') {
        let index = 3;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal3Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal3, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal3') {
          params = this.getopt1Param(this.info.ValGun2WeldCal3Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2WeldCal2Pwm' || this.settingField == 'CrrGun2SecondaryCal2') {
        let index = 2;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal2Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal2, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal2') {
          params = this.getopt1Param(this.info.ValGun2WeldCal2Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2WeldCal1Pwm' || this.settingField == 'CrrGun2SecondaryCal1') {
        let index = 1;
        let params = {}
        if (this.settingField == 'ValGun2WeldCal1Pwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2SecondaryCal1, 1, index)
        } else if (this.settingField == 'CrrGun2SecondaryCal1') {
          params = this.getopt1Param(this.info.ValGun2WeldCal1Pwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }
      else if (this.settingField == 'ValGun2MinWeldCalPwm' || this.settingField == 'CrrGun2MinSecondaryCal') {
        let index = 0;
        let params = {}
        if (this.settingField == 'ValGun2MinWeldCalPwm') {
          params = this.getopt1Param(this.toSetValue, this.info.CrrGun2MinSecondaryCal, 1, index)
        } else if (this.settingField == 'CrrGun2MinSecondaryCal') {
          params = this.getopt1Param(this.info.ValGun2MinWeldCalPwm, this.toSetValue, 2, index)
        }
        this.opt2CalibrationChange(params);
      }

    },
    openSettingDialog(obj) {
      this.titleKey = obj.titleKey;
      this.toSetValue = obj.toSetValue;
      this.settingField = obj.field;
      this.openSetting = true;
    },
    async opt0CalibrationChange() {
      let url = API_URL["systemCalOnePss"] + '?mac=' + this.mac;
      let params = new FormData();
      params.append('OptCalibItem', this.getOptCalibItem());
      params.append('OptCalibActive', this.OptCalibActive());
      params.append('ValElectrodeCalSet', this.info.PssGun2ElectrodeCal1Set);
      params.append('PssElectrodeCal', this.info.PssGun2ElectrodeCal1Disp);
      let res = await axios.post(url, params);
      if (res && res.data && res.data.code == 200) {
        return new Promise((resolve) => {
          resolve(true);
        });
      } else if (res && res.data && res.data.msg) {
        this.$Message.error(res.data.msg);
        return new Promise(() => {

        });
      } else {
        this.$Message.error(res.data.msg);
        return new Promise(() => {

        });
      }
    },
    async opt1CalibrationChange8() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration8 ? 0 : 1;
      let index = 7;
      let params = this.getopt1Param(this.info.ValGun2MaxPrimWeldCalPwm, this.info.CrrGun2MaxPrimaryCal, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange7() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration7 ? 0 : 1;
      let index = 6;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal6Pwm, this.info.CrrGun2PrimaryCal6, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange6() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration6 ? 0 : 1;
      let index = 5;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal5Pwm, this.info.CrrGun2PrimaryCal5, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange5() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration5 ? 0 : 1;
      let index = 4;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal4Pwm, this.info.CrrGun2PrimaryCal4, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange4() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration4 ? 0 : 1;
      let index = 3;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal3Pwm, this.info.CrrGun2PrimaryCal3, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange3() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration3 ? 0 : 1;
      let index = 2;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal2Pwm, this.info.CrrGun2PrimaryCal2, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange2() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration2 ? 0 : 1;
      let index = 1;
      let params = this.getopt1Param(this.info.ValGun2PrimWeldCal1Pwm, this.info.CrrGun2PrimaryCal1, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    async opt1CalibrationChange1() {
      if (this.selPrimCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt1Calibration1 ? 0 : 1;
      let index = 0;
      let params = this.getopt1Param(this.info.ValGun2MinPrimWeldCalPwm, this.info.CrrGun2MinPrimaryCal, OptCalibActive, index)
      return this.opt1CalibrationChange(params);
    },
    getopt1Param(toSet, actVal, OptCalibActive, index) {
      let params = new FormData();
      params.append('OptCalibItem', this.getOptCalibItem());
      params.append('OptCalibActive', OptCalibActive);
      params.append('NumCalibPhase', index);
      params.append('ValWeldCalPwm', toSet);
      if(this.selScale == 1){
        params.append('CrrPrimaryCal', actVal);
        params.append('CrrSecondaryCal', 0);
      } else {
        params.append('CrrPrimaryCal', 0);
        params.append('CrrSecondaryCal', actVal);
      }
      params.append('PssElectrodeCal', 0);
      params.append('ValElectrodeCalSet', 0);
      params.append('VltCapacit', 0);
      return params
    },
    async opt2CalibrationChange8() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration8 ? 0 : 1;
      let index = 7;
      let params = this.getopt1Param(this.info.ValGun2MaxWeldCalPwm, this.info.CrrGun2MaxSecondaryCal, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange7() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration7 ? 0 : 1;
      let index = 6;
      let params = this.getopt1Param(this.info.ValGun2WeldCal6Pwm, this.info.CrrGun2SecondaryCal6, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange6() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration6 ? 0 : 1;
      let index = 5;
      let params = this.getopt1Param(this.info.ValGun2WeldCal5Pwm, this.info.CrrGun2SecondaryCal5, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange5() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration5 ? 0 : 1;
      let index = 4;
      let params = this.getopt1Param(this.info.ValGun2WeldCal4Pwm, this.info.CrrGun2SecondaryCal4, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange4() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration4 ? 0 : 1;
      let index = 3;
      let params = this.getopt1Param(this.info.ValGun2WeldCal3Pwm, this.info.CrrGun2SecondaryCal3, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange3() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration3 ? 0 : 1;
      let index = 2;
      let params = this.getopt1Param(this.info.ValGun2WeldCal2Pwm, this.info.CrrGun2SecondaryCal2, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange2() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration2 ? 0 : 1;
      let index = 1;
      let params = this.getopt1Param(this.info.ValGun2WeldCal1Pwm, this.info.CrrGun2SecondaryCal1, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt2CalibrationChange1() {
      if (this.selSecCal == 0){
        this.$Message.error(this.getTranslation('p078'));
        return new Promise(() => {
        });
      }
      let OptCalibActive = this.opt2Calibration1 ? 0 : 1;
      let index = 0;
      let params = this.getopt1Param(this.info.ValGun2MinWeldCalPwm, this.info.CrrGun2MinSecondaryCal, OptCalibActive, index)
      return this.opt2CalibrationChange(params);
    },
    async opt1CalibrationChange(params) {
      let url = API_URL["systemCalOneCurrent"] + '?mac=' + this.mac;
      if (params.get('OptCalibActive') == 1 &&
        (params.get('OptCalibItem') == 0 || params.get('OptCalibItem') == 1 || params.get('OptCalibItem') == 4 || params.get('OptCalibItem') == 5 ||
          params.get('OptCalibItem') == 8 || params.get('OptCalibItem') == 9 || params.get('OptCalibItem') == 11 || params.get('OptCalibItem') == 12 ||
          params.get('OptCalibItem') == 14 || params.get('OptCalibItem') == 15)) {
        this.canJump = false
      } else if (params.get('OptCalibActive') == 0 && (params.get('OptCalibItem') == 0 || params.get('OptCalibItem') == 1 || params.get('OptCalibItem') == 4 || params.get('OptCalibItem') == 5 ||
        params.get('OptCalibItem') == 8 || params.get('OptCalibItem') == 9 || params.get('OptCalibItem') == 11 || params.get('OptCalibItem') == 12 ||
        params.get('OptCalibItem') == 14 || params.get('OptCalibItem') == 15)) {
        this.canJump = true
      }
      let res = await axios.post(url, params);
      if (res && res.data && res.data.code == 200) {
        this.$Message.success(res.data.msg);
        this.refreshPageView();
        if (params.get('OptCalibActive') == 1) {
          for (var i = 0; i < 8; i++) {
            if (i != params.get('NumCalibPhase')) {
              this.$set(this, 'opt1Calibration' + (i + 1), false)
            }
          }
        }
        return new Promise((resolve) => {
          resolve(true);
        });
      } else if (res && res.data && res.data.msg) {
        this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
        return new Promise(() => {
        });
      } else {
        this.$Message.error(this.getTranslation('c001'));
        return new Promise(() => {
        });
      }
    },
    async opt2CalibrationChange(params) {
      let url = API_URL["systemCalOneCurrent"] + '?mac=' + this.mac;
      let res = await axios.post(url, params);
      if (res && res.data && res.data.code == 200) {
        this.$Message.success(res.data.msg);
        this.refreshPageView();
        if (params.get('OptCalibActive') == 1) {
          for (var i = 0; i < 8; i++) {
            if (i != params.get('NumCalibPhase')) {
              this.$set(this, 'opt2Calibration' + (i + 1), false)
            }
          }
        }
        return new Promise((resolve) => {
          resolve(true);
        });
      } else if (res && res.data && res.data.msg) {
        this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
        return new Promise(() => {
        });
      } else {
        this.$Message.error(this.getTranslation('c001'));
        return new Promise(() => {
        });
      }
    },
    refreshPageView() {
      this.$set(this.info, this.settingField, this.toSetValue)
    },
    getOptCalibItem() {
      //电极不同，改这里
      let rs = 4
      if (this.selScale == 0) {
        rs = 6
      } else if (this.selScale == 1) {
        rs = 4
      } else if (this.selScale == 2) {
        rs = 5
      }
      return rs
    },
    OptCalibActive() {
      let rs = 0;
      if (this.opt0Calibration) {
        if (this.settingField == 'PssGun2ElectrodeCal1Disp') {
          rs = 2
        } else {
          rs = 1
        }
      } else {
        rs = 0;
      }
      return rs;
    },
    receiveMessage(message) {   
      if(this.lockSocket){
        return;
      }
      if (message.kind == 'calibration2') {
        this.info = message.data;
        this.selPrimCal = this.info.OptPrimCalDataChoose;
        this.selSecCal = this.info.OptSecCalDataChoose;           
      }
    },

    /**
     * 发送 WebSocket 消息
     * @param {Object|string} message - 要发送的消息内容
     * @returns {boolean} 发送是否成功
     */
    sendWebSocketMessage(message) {
      if (this.$refs.webSocketRef) {
        return this.$refs.webSocketRef.sendMessage(message);
      }
    },
    KindOf803(kind){
      return KindOf803(kind)
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');

.limit-field {
  width: 40%
}

.scale-input {
  width: 30%;
}

.cal-switch {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
</style>